import React from "react"
import "./DateTimeDisplayComponent.css"

const DateTimeDisplayComponent = ({ date: dateString }) => {
  const date = new Date(dateString)
  const optionsDate = { day: "2-digit", month: "short", year: "numeric" }
  const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true, timeZoneName: "short" }

  let formattedDateUppercase = dateString
  let formattedTime = ""
  try {
    formattedTime = new Intl.DateTimeFormat("en-US", optionsTime).format(date)
    const formattedDate = new Intl.DateTimeFormat("en-US", optionsDate).format(date)
    const [month, day, year] = formattedDate.replace(",", "").split(" ")
    formattedDateUppercase = `${day} ${month.toUpperCase()} ${year}`
  } catch (error) {
    console.log("Error formatting date", error)
  }

  return (
    <div className="formatted-date-time">
      <div>{formattedDateUppercase}</div>
      <div>{formattedTime}</div>
    </div>
  )
}

export default DateTimeDisplayComponent
